const seatMethods = {
    methods:{
        getSeat(seatId) {
            let seat = this._isSeatExists(seatId) ? this.seats[seatId] : null;
            seat['price'] = this.seatPricing[seat['category']];
            return seat;
        },
        /** Tells seat exists or not @return Boolean */
        _isSeatExists(seatId){
            return this.seats.hasOwnProperty(seatId);
        },
        _seatId(row,col){
            return `${row}-${col}`;
        },
        /** Returns seat label @return String */
        _seatLabel(seatId){
            let seat = this.getSeat(seatId);
            if(seat){
                return seat.label;
            }
        },
        /** Returns seat category @return Number|String 10|20|30|... */
        _seatCategory(seatId){
            let seat = this.getSeat(seatId);
            if(seat){
                return seat.category;
            }
        },
        /** Returns seat price @return String */
        _seatPrice(seatId){
            let seat = this.getSeat(seatId);
            if(seat){
                return this.seatPricing[seat['category']];
            }
        },
        /** Tells seat selected or not @return Boolean */
        _isSeatSelected(seatId){
            return this.selectedSeats.find (selectedSeat => {
                return selectedSeat.id == seatId;
            });
        },
        /** Returns seat status @return Number|String 10|20|30|... */
        _seatStatus(seatId){
            if(!this.seatsStatus.hasOwnProperty(seatId)){
                return;
            }
            return this.seatsStatus[seatId]['status'];
        },
        _isSeatAccessible(seatId){
            let seat = this.getSeat(seatId);
            if(seat){
                return seat.is_accessible;
            }
        }
    }
}
const seatCategoryMethods = {
    methods:{
        /** Returns category object @return Object  */
        _categoryClassifier(category){
            if(this.DEFINES.SEATS_CATEGORIES.hasOwnProperty(category)){
                return this.DEFINES.SEATS_CATEGORIES[category];
            }
            let regular = 10;
            return this.DEFINES.SEATS_CATEGORIES[regular];
        },
    }
}
export {seatMethods,seatCategoryMethods}
